import MapObjRoutes from './MapObjRoutes'

export default MapObjRoutes;
